import { withRouter } from 'react-router';
import {
  branch,
  compose,
  lifecycle,
  renderNothing,
  withHandlers,
  withState,
} from 'recompose';
import { connect } from 'react-redux';
import {
  getShopTipTiers,
} from '../../../auth/selectors';
import { getBarber } from '../../../main/barbers/actions';
import {
  getCurrentBarber,
  getProcessing,
} from '../../../register/tipping/selectors';
import {
  assignTip,
  cancelTipping,
  setProcessing,
  resetTippingBarbers,
  setTippingBarbers,
} from '../../../register/tipping/actions';
import Tipping from '../components/Tipping';
import { getWebreaderPaymentStatus } from '../../../register/webReader/selector';
import { getAppointment } from '../../../main/appointments/appointmentSelector';
import { getAppointment as fetchAppointment, updateAppointment } from '../../../main/appointments/actions';
import { redirectToAppointments } from '../../../main/payment/actions';

const disabledState = withState('disabled', 'setDisabled', false);

const afterTipping = props => () => {
  props.setDisabled(false);
  props.setProcessing(false);
  props.resetTippingBarbers();
  props.redirectToAppointments();
};

const TIP_DELAY = 300;

const handlers = compose(
  withHandlers({
    setTip: props => async (tipAmount) => {
      props.setDisabled(true);
      props.setProcessing(true);
      await props.updateAppointment(props.appointment.id, { tipAmount });
      setTimeout(afterTipping(props), TIP_DELAY);
    },
    getTippingDisabled: () => () => false,
  }),
  withHandlers({
    payWithTip: props => tipAmount => () => {
      props.setTip(tipAmount);
    },
    payNoTip: props => () => {
      props.setTip(0);
    },
    previousClick: () => () => {},
    nextClick: () => () => {},
  })
);

const mapStateToProps = (state, ownProps) => {
  const { appointment } = ownProps;

  return {
    tipTiers: getShopTipTiers(state),
    previousBarber: null,
    currentBarber: getCurrentBarber(state),
    nextBarber: null,
    hasMore: false,
    hasGiftCard: false,
    giftCardPaymentSelected: false,
    giftCardTipsDisabled: false,
    cashTipsEnabled: false,
    isProcessing: getProcessing(state),
    webreaderPaymentStatus: getWebreaderPaymentStatus(state),
    payments: [],
    appointment,
    title: appointment && appointment.tipAmount > 0 ? 'Modify a tip for' : undefined,
    isReaderPayment: false,
    onPaymentChange: () => {},
    selectedPayment: null,
    availableBarberTips: appointment && appointment.costs.tips.availableTips.map((tip) => {
      if (appointment.costs.tips.useFlatTips) {
        return {
          amount: tip.flatAmount,
        };
      }

      return {
        ...tip,
        label: `${tip.percentage}%`,
      };
    }),
    showSummary: false,
  };
};

const mapDispatchToProps = {
  assignTip,
  cancelTipping,
  setProcessing,
  updateAppointment,
  redirectToAppointments,
  resetTippingBarbers,
};

const withFetchAppointments = compose(
  connect((state, ownProps) => {
    const appointment = getAppointment(state, ownProps.params.appointmentId);

    return { appointment };
  }, {
    fetchAppointment,
    setTippingBarbers,
    getBarber,
  }),
  withRouter,
  lifecycle(
    {
      componentDidMount() {
        if (!this.props.appointment) {
          this.props.fetchAppointment(this.props.params.appointmentId).then(async (appointment) => {
            const barber = await this.props.getBarber(appointment.barberId);

            this.props.setTippingBarbers([{
              id: appointment.barberId,
              firstName: barber.firstName,
              priceForTip: appointment.totalCost,
            }]);
          });
        }
      },
    }
  ),
  branch(
    props => !props.appointment,
    renderNothing
  )
);

export default compose(
  withFetchAppointments,
  disabledState,
  connect(mapStateToProps, mapDispatchToProps),
  handlers,
)(Tipping);
